/* 定义状态管理对象：state*/
// 外部调用方式：
//   1: import { mapState } from "vuex";
//   2: ...mapState(['key'])  ===> 获取用户信息： ...mapState(['userInfo'])
//   3: mapState一般在vue组件的计算函数中引用
export default {
  userInfo: {}, // 用户数据
  isLogin: false, //登录状态
  isAdmin: false, //是否是管理员
}
